import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconSettings = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M15,11.2c-2.1,0-3.8,1.7-3.8,3.8c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8C18.8,12.9,17.1,11.2,15,11.2z
			 M15,17.7c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C17.7,16.5,16.5,17.7,15,17.7z M28.1,12.9l-2.7-0.4
			c-0.3-1.1-0.7-2.1-1.2-3l1.6-2.2c0.3-0.4,0.3-1-0.1-1.4l-1.5-1.5C23.9,4.1,23.7,4,23.4,4c-0.2,0-0.4,0.1-0.6,0.2l-2.2,1.6
			c-0.9-0.6-1.9-1-3-1.2l-0.4-2.7C17.1,1.4,16.6,1,16.1,1h-2.2c-0.5,0-1,0.4-1.1,0.9l-0.4,2.7c-1.1,0.3-2.1,0.7-3,1.2L7.2,4.2
			C7.1,4.1,6.8,4,6.6,4C6.3,4,6.1,4.1,5.9,4.3L4.3,5.9C4,6.2,3.9,6.8,4.2,7.2l1.6,2.2c-0.6,0.9-1,1.9-1.2,3l-2.7,0.4
			C1.4,12.9,1,13.4,1,13.9v2.2c0,0.5,0.4,1,0.9,1.1l2.7,0.4c0.3,1.1,0.7,2.1,1.2,3l-1.6,2.2c-0.3,0.4-0.3,1,0.1,1.4l1.5,1.5
			C6.1,25.9,6.3,26,6.6,26c0.2,0,0.4-0.1,0.6-0.2l2.2-1.6c0.9,0.6,1.9,1,3,1.2l0.4,2.7c0.1,0.5,0.5,0.9,1.1,0.9h2.2
			c0.5,0,1-0.4,1.1-0.9l0.4-2.7c1.1-0.3,2.1-0.7,3-1.2l2.2,1.6c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.3l1.5-1.5
			c0.4-0.4,0.4-1,0.1-1.4l-1.6-2.2c0.6-0.9,1-1.9,1.2-3l2.7-0.4c0.5-0.1,0.9-0.5,0.9-1.1v-2.2C29,13.4,28.6,12.9,28.1,12.9z
			 M27.9,16.1l-3.4,0.6c-0.2,1.5-0.8,2.8-1.6,3.9l2,2.8l-1.5,1.5l-2.8-2c-1.2,0.8-2.5,1.4-3.9,1.6l-0.6,3.4h-2.2l-0.6-3.4
			c-1.5-0.2-2.8-0.8-3.9-1.6l-2.8,2l-1.5-1.5l2-2.8c-0.8-1.2-1.4-2.5-1.6-3.9l-3.4-0.6v-2.2l3.4-0.6c0.2-1.5,0.8-2.8,1.6-3.9l-2-2.8
			l1.5-1.5l2.8,2c1.2-0.8,2.5-1.4,3.9-1.6l0.6-3.4h2.2l0.6,3.4c1.5,0.2,2.8,0.8,3.9,1.6l2.8-2l1.5,1.5l-2,2.8
			c0.8,1.2,1.4,2.5,1.6,3.9l3.4,0.6V16.1z"/>
        </g>
      </g>
    </SvgIcon>
  );
};

IconSettings.displayName = 'IconSettings';
IconSettings.muiName = 'SvgIcon';

export default IconSettings;



// WEBPACK FOOTER //
// ./src/components/Icons/IconSettings.js